import { render, staticRenderFns } from "./mult_upload.vue?vue&type=template&id=3c78f878&"
import script from "./mult_upload.vue?vue&type=script&lang=js&"
export * from "./mult_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports